import { checkAllCasesHandled } from "trader.ts/utils";
import { teacherid } from "../sql/classy/types";

export type AdminRole = { tag: "Admin" };
export type TeacherRole = { tag: "Teacher"; teacherId: teacherid };
export type StudentRole = {
  tag: "Student"; // studentId: studentid
};

export type role = AdminRole | TeacherRole | StudentRole;
export function stringToRole(str: string): role | null {
  const split = str.split("/");
  return split[0] === "Admin"
    ? { tag: "Admin" }
    : split[0] === "Teacher"
    ? { tag: "Teacher", teacherId: parseInt(split[1]) as teacherid }
    : split[0] === "Student"
    ? { tag: "Student" }
    : null;
}

export function roleToString(r: role, opts: { withSlash: boolean }): string {
  if (r.tag === "Admin") {
    return "Admin" + (opts.withSlash ? "/_" : "");
  } else if (r.tag === "Teacher") {
    return "Teacher" + (opts.withSlash ? "/" : "") + r.teacherId;
  } else if (r.tag === "Student") {
    return "Student/_"; // legacy, can be removed, just make sure encoding/decoding works
  } else {
    return checkAllCasesHandled(r);
  }
}
